import type {ConfirmDeletePanelProps} from '@Panels/confirm-delete-panel/confirm-delete-panel.types';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export type ConfirmDeleteModalProps = ConfirmDeletePanelProps;

export const openConfirmDeleteModal = (props: ConfirmDeleteModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CONFIRM_DELETE_MODAL,
      panelProps: props,
    })
  );
};
